import { render, staticRenderFns } from "./NewCurrentSaleLine.vue?vue&type=template&id=422b885b&scoped=true"
import script from "./NewCurrentSaleLine.vue?vue&type=script&lang=js"
export * from "./NewCurrentSaleLine.vue?vue&type=script&lang=js"
import style0 from "./NewCurrentSaleLine.vue?vue&type=style&index=0&id=422b885b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b885b",
  null
  
)

export default component.exports